module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "navbar-item"
  }, [_c('b-icon', {
    attrs: {
      "pack": "fab",
      "icon": "github"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "navbar-item"
  }, [_c('b-icon', {
    attrs: {
      "pack": "fab",
      "icon": "twitter"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu"
  }, [_c('div', {
    staticClass: "navbar-end"
  }, [_c('b-dropdown', {
    attrs: {
      "position": "is-bottom-left",
      "aria-role": "menu",
      "trap-focus": ""
    }
  }, [_c('a', {
    staticClass: "navbar-item",
    attrs: {
      "slot": "trigger",
      "role": "button"
    },
    slot: "trigger"
  }, [_c('span', [_vm._v("Login")]), _vm._v(" "), _c('b-icon', {
    attrs: {
      "icon": "menu-down"
    }
  })], 1), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-role": "menu-item",
      "focusable": false,
      "custom": "",
      "paddingless": ""
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "modal-card",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('section', {
    staticClass: "modal-card-body"
  }, [_c('b-field', {
    attrs: {
      "label": "Email"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "email",
      "placeholder": "Your email",
      "required": ""
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Password"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "password",
      "password-reveal": "",
      "placeholder": "Your password",
      "required": ""
    }
  })], 1), _vm._v(" "), _c('b-checkbox', [_vm._v("Remember me")])], 1), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-primary"
  }, [_vm._v("Login")])])])])])], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "navbar-item"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/buefy-logo.png",
      "alt": "Buefy"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-458f5d05"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/dropdown/examples/ExContentPosition.vue
// module id = 1066
// module chunks = 11 229